import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from "react-router-dom";

import API from "../../../Services/BaseService";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import StateAndCity from '../../../Component/StateAndCity/StateAndCity';
import ManageAccountLinks from "../../../Component/ManageAccountLinks/ManageAccountLinks";
import PhoneInput from 'react-phone-number-input/input';
import appstore from '../../../assets/img/appstore.png';
import googleplay from '../../../assets/img/googleplay.png';
import PhoneInputs from 'react-phone-input-2'
import StateAndCitySearch from '../../../Component/StateAndCity/StateAndCitySearch';
import Loading from '../../../Component/Loading/Loading';
import PageNotFound from '../../FallBackUI/PageNotFound';
import { Button } from 'antd';
import { Modal } from 'react-bootstrap';

const EditAddress = (props) => {
    const history = useHistory();
    const { id } = props.location.state;
    console.log("id", id)

    // const { id } = useParams();
    const [accountObjc, setAccountObj] = useState("");
    const [FirstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [address, setAddress] = useState("");
    const [primaryPhone, setPrimaryPhone] = useState("");
    const [mobilePhone, setMobilePhone] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zipCode, setZIpCode] = useState("");
    const [zipCodeId, setZIpCodeId] = useState("");
    const [stateCityFlag, setStateCityFlag] = useState("");
    const [changesArray, setChangesArray] = useState([]);
    const [changesFlag, setChangesFlag] = useState("no");

    const [cellFlag, setCellFlag] = useState(false);
    const [alterPhoneFlag, setAlterPhoneFlag] = useState(false);
    const [loading, setLoading] = useState(true);
    const [sateCityFlag, setSateCityFlag] = useState("");

    const [location, setLocation] = useState("");
    const [instruction, setInstruction] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [firstNameError, setFirstNameError] = useState("")
    const [lastNameError, setLastNameError] = useState("")
    const [addressError, setAddressError] = useState("")
    const [primaryPhoneError, setPrimaryPhoneError] = useState("")
    const [mobilePhoneError, setMobilePhoneError] = useState("")
    const [locationError, setLocationError] = useState("")
    const [instructionError, setInstructionError] = useState("")
    const [stateAndCityError, setStateAndCityError] = useState("")
    const successData = useSelector(state => state.LoginReducer.payload);
    console.log("==successData==", successData)
    console.log("changesArray", changesArray);

    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
    const [extentation, setExtentation] = useState("");
    const [extentationmob, setExtentationmob] = useState("");


    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");

    const [confirmationFlag, setConfirmationFlag] = useState(false);
    const [optionPhone, setOptionPhone] = useState("+1");
    const [optionPhone1, setOptionPhone1] = useState("+1");
    const [country, setCountry] = useState("");

    const confirmationPopup = () => {

        setConfirmationFlag(!confirmationFlag)

    }

    const customButtonStyle = {
        backgroundColor: "RGB(189,6,44)",
        color: "white",
        height: '40px'
    };
    const handleAddressChange = (e) => {
        setChangesFlag("yes")
        const newValue = e.target.value;
        const oldvalue = accountObjc.address;
        setAddress(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Location Address');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Location Address' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Location Address' };
            setChangesArray([...changesArray, change]);
        }
    }

    const getStateName = (stateData, flag, type) => {
        setChangesFlag("yes")

        console.log(stateData, flag, type, "checking");
        setState(stateData)
        const oldvalue = accountObjc.state_name == null ? "" : accountObjc.state_name;
        setSateCityFlag(flag)
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === 'Location state');

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue: oldvalue, newvalue: stateData, name: 'Location state' };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: stateData, name: 'Location state' };
                return [...prevChangesArray, change];
            }
        });
    }

    const getCityName = (cityData, type) => {
        setChangesFlag("yes")
        setCity(cityData)
        const oldvalue = accountObjc.city_name == null ? "" : accountObjc.city_name;
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === 'Location city');

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = {
                    ...updatedChangesArray[existingChangeIndex],
                    newvalue: cityData,
                };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: cityData, name: 'Location city' };
                return [...prevChangesArray, change];
            }
        });
    }

    const getZipCodeId = (zipData, flag, type) => {
        setChangesFlag("yes")
        console.log(zipData, flag, type, "changing flag");
        setZIpCode(zipData)
        const oldvalue = accountObjc.zipcode == null ? "" : accountObjc.zipcode;
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === 'Location zipcode');
            const updatedFlag = flag || 'dropdown';
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { ...updatedChangesArray[existingChangeIndex], newvalue: zipData, flag: updatedFlag };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: zipData, name: 'Location zipcode', flag: updatedFlag };
                return [...prevChangesArray, change];
            }
        });
    }
    // const getStateName = (stateData, flag) => {
    //     setState(stateData)
    //     setStateCityFlag(flag)

    // }

    // const getCityName = (cityData) => {
    //     setCity(cityData)
    // }

    // const getZipCodeId = (zipData) => {
    //     setZIpCode(zipData)
    // }
    const getError = (data, flag) => {
        console.log("reg flag", data, flag);
        setErrors(data)
        setErrorFlag(flag)
    }

    useEffect(() => {
        setState(state)
        setCity(city)
        setZIpCode(zipCode)
    }, []);

    const updateAddress = (event) => {
        // setOpenLoader(true);
        event.preventDefault();

        setFirstNameError("")
        setLastNameError("")
        setPrimaryPhoneError("")
        setMobilePhoneError("")
        setAddressError("")
        setLocationError("")
        setInstructionError("")
        setStateAndCityError("")


        // console.log("====request==>",request)

        if (!FirstName) {
            setFirstNameError("First Name is required")
            return;
        }
        else if (FirstName.length > 50) {
            setFirstNameError("First Name must not exceed 50 characters")
            return;
        }
        if (!lastName) {
            setLastNameError("Last Name is required")
            return;
        }
        else if (lastName.length > 50) {
            setLastNameError("Last Name must not exceed 50 characters")
            return;
        }
        if (!primaryPhone) {
            setPrimaryPhoneError("Primary Phone is required")
            return;
        }
        else if (primaryPhone.length < 10) {
            setPrimaryPhoneError("Primary Phone must have 10 digits ")
            return;
        }
        if (!mobilePhone) {
            setMobilePhoneError("Mobile Phone is required")
            return;
        }
        else if (mobilePhone.length < 10) {
            setMobilePhoneError("Mobile Phone must have 10 digits")
            return;
        }
        if (!address) {
            setAddressError("Address is required")
            return;
        }
        else if (address.length > 150) {
            setAddressError("Address must not exceed 150 characters")
            return;
        }
        if (!(typeof state === 'string' ? accountObjc.state_id : state)) {
            setStateAndCityError("1")
            return
        }
        if (!(typeof city === 'string' ? accountObjc.city_id : city)) {
            setStateAndCityError("2")
            return
        }
        if (!(zipCode === accountObjc.zipcode ? accountObjc.zipcode_id : zipCode)) {
            setStateAndCityError("3")
            return
        }
        if (!location) {
            setLocationError("Location is required")
            return;
        }
        else if (location.length > 150) {
            setLocationError("Location must not exceed 150 characters")
            return;
        }
        if (!instruction) {
            setInstructionError("Instructions is required")
            return;
        }
        else if (instruction.length > 150) {
            setInstructionError("Instruction must not exceed 150 characters")
            return;
        }
        confirmationPopup()
    }
    const updateAddress1 = () => {

        const filteredChangesArray = changesArray.filter(change => !(change.oldvalue === '' && change.newvalue === ''));
        const filteredChangesflag = filteredChangesArray.length > 0 ? "yes" : "no"

        let request = {
            seller_address_id: id,
            // seller_dealer_id:JSON.parse(localStorage.getItem("sellerDetails")).seller_dealer_id,
            first_name: FirstName,
            last_name: lastName,
            address: address,
            phone_no: cellFlag === true ? primaryPhone : accountObjc?.phone_no,
            mobile_no: alterPhoneFlag === true ? mobilePhone : accountObjc?.mobile_no,

            city_id: stateCityFlag == "" ? typeof city === 'string' ? accountObjc.city_id : city : "",
            state_id: stateCityFlag == "" ? typeof state === 'string' ? accountObjc.state_id : state : "",
            zipcode_id: stateCityFlag == "" ? zipCode === accountObjc.zipcode ? accountObjc.zipcode_id : zipCode : "",
            city_name: stateCityFlag !== "" ? city : "",
            state_name: stateCityFlag !== "" ? state : "",
            zipcode: stateCityFlag !== "" ? zipCode : "",
            location: location,
            instructions: instruction,
            seller_id: successData.seller_id,
            seller_dealer_id: successData.seller_dealer_id,
            seller_token: successData.seller_token,
            historylist: changesArray,
            valuechanges: changesFlag,
            extentation: extentation,
            mobile_extentation: extentationmob,
            country_code: optionPhone,
            mobile_country_code: optionPhone1,
            historylist: filteredChangesArray,
            valuechanges: filteredChangesflag,
            // buyer_address_id:buyeraddress,
            active: 1,
            // updatedBy:successData.seller_id

        };
        console.log("seller_address requset", request)
        // return
        API
            .post("seller_address/update", request)
            .then((response) => {
                setConfirmationFlag(false)
                if (response.data.success) {
                    const { data } = response;
                    togglePopup()
                    setPopupTitle("Edit Address");
                    setPopupMsg(" Edit Address is successfully Updated");
                    setPopupType("success");
                    setPopupActionType("redirect");
                    setPopupActionValue("ok");
                    setPopupActionPath("/manageaccount")

                } else {
                    togglePopup()
                    setPopupTitle("Edit Address");
                    // setPopupMsg("Edit Address is not update, Please try Again");
                    setPopupMsg(response.data.error.err);
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                }
            }, (error) => {
                // setOpenLoader(false);
                // console.log(error);
                togglePopup()
                setPopupTitle("Error");
                setPopupMsg("Something went wrong, Please try Again");
                setPopupType("error");
                setPopupActionType("close");
                setPopupActionValue("close");
            })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }
    useEffect(() => {
        //fetchAccountDetails();
        let request = {
            seller_address_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        };
        const state = API.post('seller_address/condition', request);
        state.then(res => {
            console.log("res", res.data.data)
            if (res.data.success === true) {
                setFirstName(res.data.data[0].first_name);
                setLastName(res.data.data[0].last_name);
                setAddress(res.data.data[0].address);
                setCity(res.data.data[0].city_name);
                setState(res.data.data[0].state_name);
                setZIpCodeId(res.data.data[0].zipcode_id);
                setLocation(res.data.data[0].location);
                setInstruction(res.data.data[0].instructions);
                setZIpCode(res.data.data[0].zipcode);
                setExtentation(res.data.data[0]?.extentation);
                setExtentationmob(res.data.data[0]?.mobile_extentation);
                setOptionPhone(res.data.data[0].country_code == null ? "+1" : res.data.data[0].country_code);
                setOptionPhone1(res.data.data[0].mobile_country_code == null ? "+1" : res.data.data[0].mobile_country_code);
                setAccountObj(res.data.data[0])
                console.log("setAccountObj", res.data.data[0]);
                // reset(res.data.data);
                if (res.data.data[0].phone_no != "") {
                    setPrimaryPhone(res.data.data[0].phone_no)
                }
                if (res.data.data[0].mobile_no != "") {
                    setMobilePhone(res.data.data[0].mobile_no);
                }
                setLoading(false);
            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }, []);
    function formatPhone(value) {
        var x = value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
        console.log("formatPhoneNumber x", x);
        value = '+1' + '(' + x[1] + ')' + x[2] + '-' + x[3];
        console.log("formatPhoneNumber", value);
        return setPrimaryPhone(value);
    }
    function formatMobile(value) {
        var x = value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
        console.log("formatPhoneNumber x", x);
        value = '+1' + '(' + x[1] + ')' + x[2] + '-' + x[3];
        console.log("formatPhoneNumber", value);
        return setMobilePhone(value);
    }
    // const handleOnChangePhone = (value) => {
    //     setPrimaryPhone(value);
    //     setCellFlag(true)
    //     console.log("inside handle")

    //     console.log("phn no", value)
    // }

    // const handleOnChangeMobile = (value) => {
    //     setMobilePhone(value);
    //     setAlterPhoneFlag(true)
    //     console.log("inside handle")

    //     console.log("phn no", value)
    // }
    const handleOnChangePhone = (value) => {
        setChangesFlag("yes")

        const newValue = value;
        const oldvalue = accountObjc.phone_no == null ? "" : accountObjc.phone_no;
        setPrimaryPhone(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Phone Number');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Phone Number' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Phone Number' };
            setChangesArray([...changesArray, change]);
        }

        // setPrimaryPhone(value);
        setCellFlag(true)
        console.log("inside handle")

        console.log("phn no", value)
    }

    const handleOnChangeMobile = (value) => {
        setChangesFlag("yes")

        const newValue = value;
        const oldvalue = accountObjc.mobile_no == null ? "" : accountObjc.mobile_no;
        setMobilePhone(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Mobile Number');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Mobile Number' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Mobile Number' };
            setChangesArray([...changesArray, change]);
        }
        setAlterPhoneFlag(true)
        console.log("inside handle")

        console.log("phn no", value)
    }

    const handleFirstNameChange = (e) => {
        setChangesFlag("yes")

        const newValue = e.target.value;
        const oldvalue = accountObjc.first_name == null ? "" : accountObjc.first_name;
        setFirstName(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'First Name');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'First Name' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'First Name' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleLastNameChange = (e) => {
        setChangesFlag("yes")

        const newValue = e.target.value;
        const oldvalue = accountObjc.last_name == null ? "" : accountObjc.last_name;
        setLastName(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Last Name');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Last Name' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Last Name' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleLocationChange = (e) => {
        setChangesFlag("yes")

        const newValue = e.target.value;
        const oldvalue = accountObjc.location == null ? "" : accountObjc.location;
        setLocation(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Location');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Location' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Location' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleInstructionChange = (e) => {
        setChangesFlag("yes")

        const newValue = e.target.value;
        const oldvalue = accountObjc.instructions == null ? "" : accountObjc.instructions;
        setInstruction(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Instruction');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Instruction' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Instruction' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleExtentationChange = (e) => {
        setChangesFlag("yes")
        console.log("check handleExtentationChange", e.target.value);
        const newValue = e.target.value;
        const oldvalue = accountObjc?.extentation == null ? "" : accountObjc?.extentation;
        setExtentation(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Extension');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Extension' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Extension' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleLables = (value, label) => {
        setChangesFlag("yes")
        if (label === "Primary Phone # Extension") {
            console.log("check the changing value");
            const oldvalue = accountObjc?.extentation == "null" || accountObjc?.extentation == null || accountObjc?.extentation == "undefined" ? "" : accountObjc?.extentation;
            const data = value.replace(/\D/g, "");
            setExtentation(data)

            const existingChangeIndex = changesArray.findIndex((change) => change.name === label);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: data, name: label };
                setChangesArray(updatedChangesArray);
            } else {
                const change = { oldvalue: oldvalue, newvalue: data, name: "Primary Phone # Extension" };
                setChangesArray([...changesArray, change]);
            }

        }
        if (label === "Primary Phone # Country Code") {
            console.log("check the changing value");
            const oldvalue = accountObjc?.country_code == "null" || accountObjc?.country_code == null || accountObjc?.country_code == "undefined" ? "" : accountObjc?.country_code;
            const data = value;
            setOptionPhone(data)

            const existingChangeIndex = changesArray.findIndex((change) => change.name === label);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: data, name: label };
                setChangesArray(updatedChangesArray);
            } else {
                const change = { oldvalue: oldvalue, newvalue: data, name: "Primary Phone # Country Code" };
                setChangesArray([...changesArray, change]);
            }

        }
        if (label === "Mobile Phone # Country Code") {
            console.log("check the changing value");
            const oldvalue = accountObjc?.mobile_country_code == "null" || accountObjc?.mobile_country_code == "undefined" || accountObjc?.mobile_country_code == null ? "" : accountObjc?.mobile_country_code;
            const data = value;
            setOptionPhone1(data)

            const existingChangeIndex = changesArray.findIndex((change) => change.name === label);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: data, name: label };
                setChangesArray(updatedChangesArray);
            } else {
                const change = { oldvalue: oldvalue, newvalue: data, name: "Mobile Phone # Country Code" };
                setChangesArray([...changesArray, change]);
            }

        }
    }

    const handleMobileLables = (value, label) => {
        setChangesFlag("yes")
        if (label === "Mobile Phone # Extension") {
            console.log("check the changing value");
            const oldvalue = accountObjc?.mobile_extentation == null || accountObjc?.mobile_extentation == "undefined" || accountObjc?.mobile_extentation == "null" ? "" : accountObjc?.mobile_extentation;
            const data = value.replace(/\D/g, "");
            setExtentationmob(data)

            const existingChangeIndex = changesArray.findIndex((change) => change.name === label);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: data, name: label };
                setChangesArray(updatedChangesArray);
            } else {
                const change = { oldvalue: oldvalue, newvalue: data, name: "Mobile Phone # Extension" };
                setChangesArray([...changesArray, change]);
            }

        }
    }
    useEffect(() => fetchCountry()
        , [])

    async function fetchCountry() {
        const country = API.get('country');
        country.then((response) => {

            if (response.data.success === true) {
                setCountry(response.data.data);
            }
            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }

        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }
    return (
        <div>



            <main id="main" className="inner-page">
                {errorFlag === true ? <PageNotFound error={errors} /> :
                    <>
                        {loading ? <Loading /> :
                            <div id="addaddress" className="addaddress_block">
                                <div className="container-fluid inner-page-space">
                                    <div class="common-heading">
                                        <div className="row">
                                            <div className="col-lg-4">
                                            </div>
                                            <div className="col-lg-4">
                                                <div class="title">
                                                    <p class="inner-title">Edit Address</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="addaddressblock col-lg-12">
                                        <div className="row content">
                                            <div className="col-lg-4 col-md-12 col-sm-12 mgaccountleftblock">
                                                <ManageAccountLinks />
                                            </div>
                                            <div className="col-lg-8 col-md-12 col-sm-12 flooraddform">
                                                <div className="adduserpage-inner">
                                                    <div className="col-lg-12">
                                                        <form className="registrationform"  >
                                                            <div className="row">
                                                                <div class="common-heading">
                                                                    <div className="row">
                                                                        <div className="col-lg-2">
                                                                            <div class="back-btn">
                                                                                <button className="back-btn-paymentform backBtn" onClick={() => history.push("/manageaccount")}><i className="icofont-arrow-left"></i> Back</button>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-8">
                                                                            <div class="title">
                                                                                <p class="inner-title">Edit Address</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.first_name} className="textbox" placeholder="" /* onBlur={(e) => setFirstName(e.target.value)} */ onChange={handleFirstNameChange} />
                                                                        <label htmlFor="first_name" className={"input-has-value required"}>First Name</label>
                                                                        <p className="form-input-error" >{firstNameError}</p>

                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.last_name} className="textbox" placeholder="" /* onBlur={(e) => setLastName(e.target.value)} */ onChange={handleLastNameChange} />
                                                                        <label htmlFor="last_name" className={"input-has-value required"}>Last Name</label>
                                                                        <p className="form-input-error" >{lastNameError}</p>

                                                                    </div> </div>
                                                                <div className="col-sm-4 form-group countrycode">
                                                                    <div className="tbox">
                                                                        <select className="form-control custom-select browser-default textbox" id="drop" placeholder=""
                                                                            onChange={(e) => { handleLables(e.target.value, "Primary Phone # Country Code") }} value={optionPhone}
                                                                        >
                                                                            <option style={{ display: "none" }}>{optionPhone}</option>
                                                                            {country.length > 0 &&
                                                                                <>
                                                                                    {country.map((country) => <>
                                                                                        <option key={country.id} value={`+${country.country_code}`} >
                                                                                            {country?.country_name}({`+${country.country_code}`})
                                                                                        </option>
                                                                                    </>)}
                                                                                </>}
                                                                        </select>
                                                                        <label for="drop" className={"input-has-value"}>Country Code</label>

                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-5 form-group ">
                                                                    <div className="tbox ">
                                                                        {/* <PhoneInput value={primaryPhone} country="US" className="textbox" maxLength="14" minLength="14" onChange={handleOnChangePhone} ></PhoneInput> */}
                                                                        <PhoneInputs
                                                                            className="textbox"
                                                                            country={'us'}
                                                                            disableDropdown={true}
                                                                            disableCountryCode={true}
                                                                            onlyCountries={['us']}
                                                                            value={primaryPhone}
                                                                            onChange={(data) => handleOnChangePhone(data)}
                                                                            placeholder=""
                                                                        ></PhoneInputs>
                                                                        <label for="primary_phone" className={"input-has-value required"}>Primary Phone #</label>
                                                                    </div>
                                                                    <p className="form-input-error1" >{primaryPhoneError}</p>
                                                                </div>

                                                                <div className="col-sm-3 form-group">
                                                                    <div className="tbox ">
                                                                        <input
                                                                            type="text"
                                                                            class="form-control"
                                                                            id="extentation1"
                                                                            value={extentation !== "null" ? extentation : ""}
                                                                            // onChange={(e) => onhandleExtentation(e.target.value)}
                                                                            onChange={(e) => { handleLables(e.target.value, "Primary Phone # Extension"); }}

                                                                        />
                                                                        <label for="drop" className={"input-has-value"}>Extension</label>

                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-4 form-group countrycode">
                                                                    <div className="tbox">
                                                                        <select className="form-control custom-select browser-default textbox" id="drop" placeholder=""
                                                                            onChange={(e) => { handleLables(e.target.value, "Mobile Phone # Country Code") }} value={optionPhone1}
                                                                        >
                                                                            <option style={{ display: "none" }}>{optionPhone1}</option>
                                                                            {country.length > 0 &&
                                                                                <>
                                                                                    {country.map((country) => <>
                                                                                        <option key={country.id} value={`+${country.country_code}`} >
                                                                                            {country?.country_name}({`+${country.country_code}`})
                                                                                        </option>
                                                                                    </>)}
                                                                                </>}
                                                                        </select>
                                                                        <label for="drop" className={"input-has-value"}>Country Code</label>

                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-5 form-group ">
                                                                    <div className="tbox ">
                                                                        {/* <PhoneInput value={mobilePhone} country="US" className="textbox" maxLength="14" minLength="14" onChange={handleOnChangeMobile} ></PhoneInput> */}
                                                                        <PhoneInputs
                                                                            className="textbox"
                                                                            country={'us'}
                                                                            disableDropdown={true}
                                                                            disableCountryCode={true}
                                                                            onlyCountries={['us']}
                                                                            value={mobilePhone}
                                                                            onChange={(data) => handleOnChangeMobile(data)}
                                                                            placeholder=""
                                                                        ></PhoneInputs>
                                                                        <label for="mobile_phone" className={"input-has-value required"}>Mobile Phone #</label>
                                                                    </div>
                                                                    <p className="form-input-error1" >{mobilePhoneError}</p>
                                                                </div>
                                                                <div className="col-sm-3 form-group">
                                                                    <div className="tbox ">
                                                                        <input
                                                                            type="text"
                                                                            class="form-control"
                                                                            id="extentation2"
                                                                            value={extentationmob !== "null" ? extentationmob : ""}
                                                                            // onChange={(e) => handleMobileLables(e.target.value)}
                                                                            onChange={(e) => { handleMobileLables(e.target.value, "Mobile Phone # Extension"); }}

                                                                        />
                                                                        <label for="drop" className={"input-has-value"}>Extension</label>

                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.address} className="textbox" placeholder="" onChange={handleAddressChange} />
                                                                        <label htmlFor="address" className={"input-has-value required"}>Address</label>
                                                                        <p className="form-input-error" >{addressError}</p>

                                                                    </div> </div>

                                                                {/* <StateAndCitySearch
                                                                    setStateValue={getStateName}
                                                                    setCityValue={getCityName}
                                                                    setZipcodeValue={getZipCodeId}
                                                                    setNewError={getError}
                                                                    isEdit={true}
                                                                    defaultStateValue={state}
                                                                    defaultCityValue={city}
                                                                    defaultZipcodeValue={zipCode}
                                                                    stateCityValidation={stateAndCityError}
                                                                    setRequired="true"

                                                                /> */}
                                                                <StateAndCitySearch
                                                                    setStateValue={(stateData, flag) => getStateName(stateData, flag, 'state')}
                                                                    setCityValue={(cityData) => getCityName(cityData, 'city')}
                                                                    setZipcodeValue={(zipData, flag) => getZipCodeId(zipData, flag, 'zipcode')}
                                                                    setNewError={getError}
                                                                    isEdit={true}
                                                                    defaultStateValue={state}
                                                                    defaultCityValue={city}
                                                                    defaultZipcodeValue={zipCode}
                                                                    stateCityValidation={stateAndCityError}
                                                                    setRequired={"true"}

                                                                />
                                                                {/* <div className="col-sm-12 form-group">
                                                        <p className="form-input-error1"> {stateAndCityError} </p>
                                                        </div> */}
                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.location} className="textbox" placeholder="" onChange={handleLocationChange} />
                                                                        <label htmlFor="location" className={"input-has-value required"}>Location</label>
                                                                        <p className="form-input-error" >{locationError}</p>

                                                                    </div> </div>
                                                                <div className="col-sm-12 form-group">
                                                                    <div className="tbox">
                                                                        <input type="text" defaultValue={accountObjc.instructions} className="textbox" placeholder="" onChange={handleInstructionChange} />
                                                                        <label htmlFor="instructions" className={"input-has-value required"}>Instructions</label>
                                                                        <p className="form-input-error" >{instructionError}</p>

                                                                    </div> </div>
                                                                {/* <div class="col-sm-12 form-group">
                                <input type="text" defaultValue={accountObjc.city_name} class="form-control" placeholder="City" onChange={(e) => setCity(e.target.value)} />
                            </div>
                            <div class="col-sm-12 form-group">
                                <input type="text" defaultValue={accountObjc.state_name} class="form-control" placeholder="State" onChange={(e) => setState(e.target.value)} />
                            </div>
                            <div class="col-sm-12 form-group">
                                <input type="number" defaultValue={accountObjc.zipcode_id} class="form-control" placeholder="Zip code" onChange={(e) => setZIpCode(e.target.value)} />
                            </div> */}

                                                                <div className="col-lg-12 loginBtn">
                                                                    <Button className="cta-btn" style={customButtonStyle} onClick={updateAddress} >Update</Button>
                                                                </div>
                                                            </div>
                                                        </form>

                                                    </div></div></div></div> </div></div></div>}</>}

                {confirmationFlag &&
                    < >

                        <Modal show={true} onHide={confirmationPopup} centered>
                            <Modal.Header className="Terms-login">
                                <h2>Edit confirmation</h2>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="CommonModalbody">

                                    <p>Are you sure,If you want to Edit Address Information please confirm</p>
                                </div>

                                <div className="col-md-12 btns confirmation ">
                                    <button className="cta-btns" onClick={confirmationPopup} >CANCEL</button>
                                    <button className="cta-btns" onClick={updateAddress1} >OK</button>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </>}

                <section id="playstoreBlock" className="playstoreBlock">
                    <div className="container">
                        <div className="row content">
                            <div className="col-lg-12">
                                <img src={appstore} />
                                <img src={googleplay} />
                            </div>
                        </div>
                    </div>
                </section>
                {isOpen &&
                    <CommonPopup
                        handleClose={togglePopup}
                        popupTitle={popupTitle}
                        popupMsg={popupMsg}
                        popupType={popupType}
                        popupActionType={popupActionType}
                        popupActionValue={popupActionValue}
                        popupActionPath={popupActionPath}
                    />}
            </main>

        </div>


    );
};

export default EditAddress;